import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { SelectItem } from 'primeng/api';
import { CommonPatientModel } from 'src/app/model/common/patient';
import { CommonPatientViewModel } from 'src/app/model/common/patient.view';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';

export interface CommonPatientState {
  result: VonPageResponseModel<CommonPatientViewModel>;
  data: CommonPatientModel;
  residence: SelectItem<KhuyanaSelectItemModel>;
}

export const commonPatientIS: CommonPatientState = {
  result: {
    content: [],
    last: false,
    totalPages: 0,
    totalElements: 0,
    size: 0,
    numberOfElements: 0,
    number: 0,
  },
  data: {},
  residence: { value: {} },
};
